import { nanoid } from "nanoid";

export const createMessageBoxSlice = (set) => ({
  // stack: for multi message instance
  stack: [],

  // new message will be pushed onto the stack
  //
  // type: 'confirm' | 'alert' | 'error' | 'prompt'
  pushMessage: ({ type, title, description, time, responseHandler }) => {
    const id = nanoid();
    set((state) => {
      state.messageBox.stack.push({
        id,
        type,
        title,
        description,
        time,
        responseHandler,
      });
    });
    return id;
  },

  // remove the id when the message is closed
  popMessage: (id) => {
    set((state) => {
      state.messageBox.stack = state.messageBox.stack.filter(
        (msg) => msg.id !== id
      );
    });
  },
});
